import {makeAutoObservable, runInAction} from "mobx";
import {VISIBLE_TIME_OUT} from "@/components/constants";
import {getStore, useStore} from "./index.jsx";

/**
 * @typedef {object} ModalData
 * @property {Object} modalProps
 * @property {string} title
 * @property {*} component
 * @property {Function|null} closeFunc
 * @property {Function|null} confirmFunc
 * @property {boolean} isFirst
 */



/**
 * 공통 Modal 상태 관리 Store
 */
export class ModalStore {

    /**
     * 현재 오픈된 모달 리스트
     * 다중 모달 구조로 관리
     * @type {Array<string | ModalData>}
     */
    MODAL_INIT_OPENED = [];

    constructor(store) {
        this.store = store;
        makeAutoObservable(this, {}, {autoBind: true});
    }

    /**
     * 모달 오픈 및 데이터 세팅 함수
     * 모달 데이터를 배열에 추가 후 visible 상태 활성화
     *
     * @param {Object} config 모달 설정 객체
     */
    openModal(config) {
        const modalData = {
            modalProps: config.modalProps,
            title: config.modalProps.title,
            component: config.component,
            closeFunc: config.closeFunc || null,
            confirmFunc: config.confirmFunc || null,
            isFirst: config.isFirst,
            visible: false,
        };
        this.MODAL_INIT_OPENED.push(modalData);
        setTimeout(() => {
            runInAction(() => {
                this.MODAL_INIT_OPENED[this.MODAL_INIT_OPENED.length - 1] = {
                    ...modalData,
                    visible: true,
                };
            });
        }, 50);
    }


    /**
     * 현재 가장 마지막 모달 닫기 함수
     * 다중 모달 구조에서 마지막 모달 visible 상태를 false 처리 후 제거
     */
    pop() {
        const lastIdx = this.MODAL_INIT_OPENED.length - 1;
        const lastModal = this.MODAL_INIT_OPENED[lastIdx];
        if (!lastModal) return;
        this.MODAL_INIT_OPENED[lastIdx] = {
            ...lastModal,
            visible: false,
        };
        setTimeout(() => {
            runInAction(() => {this.MODAL_INIT_OPENED.pop()});
        }, VISIBLE_TIME_OUT);
    }
}

/**
 * ModalStore Hook
 *
 * @returns {ModalStore}
 */
export const useModalStore = () => {
    return useStore().modalStore;
}



/**
 * ModalStore 직접 접근 함수
 *
 * @returns {ModalStore}
 */
export const getModalStore = () => {
    return getStore().modalStore;
}